import { useStyles } from '@gorila-shared-ui/components';
import React, { useEffect } from 'react';
import { Rnd } from 'react-rnd';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { useWindowSize } from 'usehooks-ts';
import { DEFAULT_BOTTOM_CARD_HEIGHT } from '../../../constants/app';
import { bottomCardHeightState, floatingCardsXPositionState, sidenavWidthState } from '../../../storage/app';
import { BottomCard } from '../../../types/app';

type Props = Readonly<{
  children: React.ReactNode;
  padding?: string;
  name: BottomCard;
  windowHeight?: number;
}>;

function FloatingBottomCard({ children, padding, name, windowHeight = DEFAULT_BOTTOM_CARD_HEIGHT }: Props) {
  const { css, theme } = useStyles();
  const { width, height } = useWindowSize();
  const xPosition = useRecoilValue(floatingCardsXPositionState);
  const sidenavWidth = useRecoilValue(sidenavWidthState(false));
  const initialWindowWidth = width - xPosition - sidenavWidth - 108;
  const windowYPosition = height - windowHeight - 60 - 26;
  padding = padding ?? theme.sizing.scale600;
  const [cardHeight, setCardHeight] = useRecoilState(bottomCardHeightState(name));
  const resetCardHeight = useResetRecoilState(bottomCardHeightState(name));

  useEffect(() => {
    return () => {
      resetCardHeight();
    };
  }, []);

  useEffect(() => {
    if (windowHeight) {
      setCardHeight(windowHeight);
    }
  }, [windowHeight]);

  return (
    <Rnd
      default={{
        x: xPosition + 12,
        y: windowYPosition,
        width: initialWindowWidth,
        height: windowHeight || cardHeight,
      }}
      minWidth={initialWindowWidth}
      className={css({
        padding,
        backgroundColor: '#fff',
        border: '1px solid #E2E2E2',
        borderRadius: theme.sizing.scale500,
        display: 'flex',
        overflow: 'hidden',
        width: '100%',
      })}
      enableResizing={false}
      bounds="body"
      disableDragging
      position={{
        x: xPosition + 12,
        y: windowYPosition,
      }}
      size={{
        height: cardHeight,
        width: initialWindowWidth,
      }}
    >
      {children}
    </Rnd>
  );
}

export default FloatingBottomCard;
